import ForumTopicCard from "components/forum/ForumTopicCard";
import type { IPostRepliesQuery } from "lib/graphql/queries/engagement/__generated__/PostRepliesQuery.generated";
import { CheckCircleIcon, MoveRightIcon } from "lucide-react";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import Editor from "components/editor/Editor";
import Link from "next/link";
import ptBR from "date-fns/locale/pt-BR";
import { FormattedMessage } from "react-intl";

interface ForumTopicQuestionCardProps {
  topic: NonNullable<IPostRepliesQuery["postByShortId"]>;
  onReply: () => void;
}

export function ForumTopicQuestionCard({ topic, onReply }: ForumTopicQuestionCardProps) {
  if (topic.__typename !== "ForumPost") {
    return null;
  }

  return (
    <ForumTopicCard
      topic={topic}
      className="border border-brand"
      postShortId={topic.shortId}
      url={topic.url}
      contextKey={topic.contextKey}
      contextType={topic.contextType}
      onReply={onReply}
    >
      {topic.replyAnswer && (
        <div key={`reply-answer/${topic.replyAnswer.shortId}`} className="col-span-3 -mx-4 -mb-8 md:-mx-8">
          <div className="col-span-3 flex w-full flex-col space-y-5 rounded-bl rounded-br bg-green-200 p-4 md:px-8">
            <div className="flex items-center space-x-2">
              <CheckCircleIcon className="h-8 w-8 fill-green-600" />

              <span className="font-aeonik text-sm font-medium text-green-600">
                <FormattedMessage description="Funcionalidades do fórum" defaultMessage="Respondido por" id="a+Vwhe" />{" "}
                <strong className="font-black">{topic.replyAnswer.author.fullName}</strong>
              </span>

              <div className="flex space-x-1">
                <span className="font-aeonik text-sm text-gray-600">
                  <FormattedMessage
                    description="Funcionalidade do fórum onde marca quando foi respondido (temporal)"
                    defaultMessage="em"
                    id="QnqAXd"
                  />
                </span>
                <span className="font-aeonik text-sm capitalize text-gray-600">
                  {format(parseISO(topic.replyAnswer.createdAt), "LLLL dd, yyyy", { locale: ptBR })}
                </span>
              </div>
            </div>

            <div
              style={{
                WebkitMaskImage: "linear-gradient(to bottom, black calc(100% - 12px), transparent 100%)",
              }}
            >
              <Editor
                className="max-h-32 overflow-hidden bg-inherit"
                editable={false}
                initialState={topic.replyAnswer.bodyAsJson}
              />
            </div>

            <Link
              href={`/forum/${topic.shortId}/replies/${topic.replyAnswer.shortId}`}
              className="flex space-x-1 text-blue-600"
            >
              <span className="font-aeonik text-sm font-medium hover:underline">
                <FormattedMessage description="Funcionalidades do fórum" defaultMessage="Ver resposta" id="YG3zB1" />
              </span>
              <MoveRightIcon className="h-5 w-5" />
            </Link>
          </div>
        </div>
      )}
    </ForumTopicCard>
  );
}
